module.exports = __webpack_public_path__ + "img/retrospect-124.efb25ca7.jpg";